var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSetComparison = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M10 0c4.327 0 8.013 2.749 9.405 6.595A10.003 10.003 0 0 1 26 16c0 5.523-4.477 10-10 10a10.004 10.004 0 0 1-9.405-6.595A10.003 10.003 0 0 1 0 10C0 4.477 4.477 0 10 0zm9.997 10.253L20 10c0 5.438-4.34 9.862-9.746 9.997a7 7 0 1 0 9.743-9.744zM16 9a7 7 0 0 0-6.938 7.938 7 7 0 0 0 7.875-7.876A7.093 7.093 0 0 0 16 9zm-6-6a7 7 0 0 0-3.997 12.747L6 16c0-5.438 4.34-9.862 9.746-9.997A6.987 6.987 0 0 0 10 3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSetComparison);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/set-comparison.07142b41ad32294f2d01ecc15c155dc2.svg";